import React from "react";
import "./Footer.css";
import TwitterIcon from "../../assets/icons/twitter.svg";
import InstagramIcon from "../../assets/icons/instagram.svg";
import LinkedinIcon from "../../assets/icons/linkedin.svg";
const Footer = () => {
  return (
    <div className="footer__section">
      <div className="footer__section_left">
        Copyright 2021 by Serenetax All Right Reserved.
      </div>
      <div className="footer__section_right">
        <div className="footer__secright_cnticns">
          <img src={TwitterIcon} className="footer__secright_cnticn" />
          <img src={InstagramIcon} className="footer__secright_cnticn" />
          <img src={LinkedinIcon} className="footer__secright_cnticn" />
        </div>
      </div>
    </div>
  );
};

export default Footer;
